module.exports = __webpack_public_path__ + "img/updated-flows.c0f00068.jpg";